import { msalInstance } from "./index";
import { loginRequest } from "./authConfig";

const getBaseUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_API_URL;
  }
  return process.env.REACT_APP_API_URL || window.location.origin;
};

export async function apiFetch(path, options = {}) {
  const base = getBaseUrl();
  const url = base ? new URL(path, base).toString() : path;

  // ambil account aktif dari MSAL
  const account = msalInstance.getActiveAccount();
  let token = null;

  if (account) {
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
      });
      token = response.accessToken;
    } catch (error) {
      console.error("Failed to get access token:", error);
    }
  }

  // merge headers
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  return fetch(url, {
    credentials: "include", // kalau masih perlu cookie
    ...options,
    headers,
  });
}
